import { c as _c } from "react/compiler-runtime";
import { Badge } from "@/components/ui/badge";
import type { MatchedAttribute } from "@/lib/search/types";
interface Props {
  attrs: MatchedAttribute[];
}
export function MatchedAttributesBadges(t0) {
  const $ = _c(4);
  const {
    attrs
  } = t0;
  if (attrs.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== attrs) {
    t1 = attrs.map(_temp);
    $[0] = attrs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex flex-wrap gap-1.5" data-testid="matched-attributes">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(attr) {
  return <Badge key={`${attr.label}-${attr.value}`} variant="secondary" className="text-[10px] pl-0!">{attr.label ? `${attr.label}: ${attr.value}` : attr.value}</Badge>;
}